import React from "react";
import { ShieldCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
export default function Introduction() {
  return <section data-section-id="264445" id="introduction" className="bg-[#0F172A] py-14 md:py-18 lg:py-20 relative overflow-hidden min-h-screen flex items-center scroll-mt-[120px] snap-start">
      <div className="max-w-7xl mx-auto px-6 transition-all duration-1000 ease-out opacity-100 translate-y-0">
        <div className="text-center mb-12">
          <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-[#F8FAFC] mb-6 leading-tight break-words">
            Privacy Policy
          </h1>
          <p className="font-default text-lg md:text-xl leading-relaxed text-[#CBD5E1] max-w-3xl mx-auto break-words">
            How Future Experts for Technical Consultancy handles website inquiries and business contact information.
          </p>
        </div>

        <Card className="bg-[#142033] border-[rgba(19,184,200,0.18)] border shadow-xl overflow-hidden rounded-lg">
          <CardContent className="p-8 md:p-10">
            <div className="flex flex-col md:flex-row items-start gap-6">
              <div className="p-3 bg-[#13B8C8]/10 rounded-lg">
                <ShieldCheck className="w-8 h-8 text-[#13B8C8]" aria-hidden="true" />
              </div>
              <div className="flex-1">
                <h2 className="text-xl font-semibold text-[#F8FAFC] mb-4">
                  Policy Overview
                </h2>
                <p className="text-[#CBD5E1] leading-relaxed">
                  At Future Experts for Technical Consultancy (FETC), we are committed to protecting your privacy and ensuring the security of your information. This policy outlines our practices regarding the collection, use, and safeguarding of data obtained through our website and business interactions. We implement reasonable administrative, technical, and organizational safeguards to protect your information against unauthorized access or disclosure.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}